import React, { useCallback, useEffect, useState } from "react";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

const DISMISS_MS = 4000;

let pushToast = null;

export const toast = {
  success: (message) => pushToast?.({ type: "success", message }),
  error: (message) => pushToast?.({ type: "error", message }),
};

export const ToastProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  const add = useCallback(({ type, message }) => {
    const id = `${Date.now()}-${Math.random()}`;
    setItems((prev) => [...prev, { id, type, message }]);
    window.setTimeout(() => {
      setItems((prev) => prev.filter((t) => t.id !== id));
    }, DISMISS_MS);
  }, []);

  useEffect(() => {
    pushToast = add;
    return () => {
      pushToast = null;
    };
  }, [add]);

  return (
    <>
      {children}
      <div
        className="fixed top-20 left-1/2 -translate-x-1/2 z-[400] flex flex-col gap-2 w-[min(22rem,calc(100vw-2rem))] pointer-events-none"
        aria-live="polite"
      >
        {items.map(({ id, type, message }) => (
          <div
            key={id}
            role={type === "error" ? "alert" : "status"}
            className={`pointer-events-auto flex items-start gap-2 px-4 py-3 rounded-xl shadow-lg border text-sm ${
              type === "success"
                ? "bg-surface-lowest border-primary-fixed-dim text-on-primary-fixed-var"
                : "bg-error-container/90 border-error/30 text-error"
            }`}
          >
            {type === "success" ? (
              <FaCheckCircle className="text-primary shrink-0 mt-0.5" size={16} />
            ) : (
              <FaExclamationCircle className="shrink-0 mt-0.5" size={16} />
            )}
            <span className="flex-1 leading-snug">{message}</span>
          </div>
        ))}
      </div>
    </>
  );
};
